// End collections //
import InputView from '../views/inputview';
import RadioView from '../views/radioview';
import AddressForm from '../views/addressformview';

const formFields = [
  {
    modelKey: 'firstName',
    label: 'First Name*',
    template: 'textViewTpl',
    readonly: '',
    required: 'required',
    valRequired: 'First name is required.',
    view: InputView,
    id: 'firstName'
  },
  {
    modelKey: 'lastName',
    label: 'Last Name*',
    template: 'textViewTpl',
    readonly: '',
    required: 'required',
    valRequired: 'Last name is required.',
    view: InputView,
    id: 'lastName'
  },
  {
    modelKey: 'email',
    label: 'Email*',
    template: 'textViewTpl',
    readonly: 'readonly',
    required: '',
    valRequired: '',
    view: InputView,
    id: 'email'
  },
  {
    modelKey: 'newEmail',
    label: 'New Email',
    template: 'textViewTpl',
    readonly: '',
    required: '',
    valRequired: '',
    view: InputView,
    id: 'newEmail'
  },
  {
    modelKey: 'primaryPhone',
    label: 'Phone',
    template: 'textViewTpl',
    readonly: '',
    required: '',
    valRequired: '',
    view: InputView,
    id: 'primaryPhone'
  },
  {
    modelKey: 'userAddress',
    view: AddressForm
  },
  {
    modelKey: 'isActive',
    label: 'Active',
    template: 'radioViewTpl',
    readonly: '',
    required: '',
    view: RadioView,
    id: 'isActive'
  },
  {
    modelKey: 'showLocation',
    label: 'Show Location',
    template: 'radioViewTpl',
    readonly: '',
    required: '',
    view: RadioView,
    id: 'showLocation'
  },
  {
    modelKey: 'save',
    template: 'submitTpl',
    view: InputView
  }
];

/*
 {
 modelKey: 'userAddress-countryID',
 label: 'Country*',
 template: 'selectViewTpl',
 collection: new Countries(),
 view: SelectView,
 id: 'countries',
 required: "required",
 valRequired: "Country is required.",
 trigger: 'changedCountry',
 onChange: 'changeCountry'
 },
 {
 modelKey: 'userAddress-address1',
 label: 'Address 1*',
 template: 'textViewTpl',
 readonly: "",
 required: "required",
 valRequired: "Address 1 is required.",
 view: InputView,
 id: 'userAddress-address1'
 },
 {
 modelKey: 'userAddress-address2',
 label: 'Address 2',
 template: 'textViewTpl',
 readonly: "",
 required: "",
 valRequired: "",
 view: InputView,
 id: 'userAddress-address2'
 },
 {
 modelKey: 'userAddress-city',
 label: 'City*',
 template: 'textViewTpl',
 readonly: "",
 required: "required",
 view: InputView,
 valRequired: "City is required.",
 id: 'userAddress-city'
 },
 {
 modelKey: 'userAddress-stateID',
 label: 'State*',
 template: 'selectViewTpl',
 collection: new States(),
 view: SelectView,
 required: "required",
 valRequired: "State is required.",
 id: 'userAddress-stateID'
 },
 {
 modelKey: 'userAddress-province',
 label: 'Province*',
 template: 'textViewTpl',
 hidden: true,
 readonly: "",
 required: "",
 view: InputView,
 valRequired: "Province is required.",
 id: 'userAddress-province'
 },
 {
 modelKey: 'userAddress-zipCode',
 label: 'Zip Code*',
 template: 'textViewTpl',
 readonly: "",
 required: "required",
 view: InputView,
 valRequired: "Zip code is required.",
 id: 'userAddress-zipCode'
 },
 {
 modelKey: 'userAddress-intlPostalCode',
 label: 'Postal Code*',
 template: 'textViewTpl',
 readonly: "",
 hidden: true,
 required: "",
 view: InputView,
 valRequired: "Postal code is required.",
 id: 'userAddress-intlPostalCode'
 },
 */

export default formFields;
